import { render, staticRenderFns } from "./PlayerMainControls.vue?vue&type=template&id=b21fd53c&scoped=true&"
import script from "./PlayerMainControls.vue?vue&type=script&lang=js&"
export * from "./PlayerMainControls.vue?vue&type=script&lang=js&"
import style0 from "./PlayerMainControls.vue?vue&type=style&index=0&id=b21fd53c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b21fd53c",
  null
  
)

component.options.__file = "PlayerMainControls.vue"
export default component.exports